import React from "react";
import { LicenseFeatureContent } from "../Component/LicenseFeatureContent";
import SEO from "../../../global/components/SEO/SEO";
import { getSEOData } from "../../../global/utils/constants/seoConfig";

const LicenseFeature = () => {
  const seoData = getSEOData("/license-feature");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <LicenseFeatureContent />
    </>
  );
};

export default LicenseFeature;
